<template>
  <CustomForm :header="header">
    <div class="row block_verification" v-if="!toPayment">
      <div class="flex">
        <div class="verification_email" v-if="!codeRequested">
          <CustomInput v-model="email" type="email" :element.sync="email" placeholder="" :disabled="true"/>
          <p v-if="isValidEmail"></p>
          <p class="errmsg" v-else style='color:red'>Эл.адрес введен неверно</p>
        </div>
        <div class="send_code" v-if="!codeRequested">
          <button class="btn btn-success get-code" :class="{'disabled' : !isValidEmail}" @click="getCode()">Запросить
            код подтверждения
          </button>
        </div>
      </div>
      <loading-block v-if="loading && !codeRequested"></loading-block>
      <div class="col-12 col-md-4" v-if="codeRequested">
        <CustomInput label="Введите код подтверждения" v-model="code" :element.sync="code" placeholder=""/>
        <p :class="infoVerify.color" v-if="!infoVerify.hidden">{{ infoVerify.text }}</p>
        <div v-else>Код подтверждения отправлен на указанную почту</div>
      </div>
      <div class="col-12 col-md-2" v-if="codeRequested">
        <button class="btn btn-success code-button confirm_btn"
                :class="{'disabled' : infoVerify.result, 'disabled' : !isValidEmail}" @click="verifyCode()"
                :disabled="infoVerify.result">
          Подтвердить
        </button>
      </div>
      <loading-block v-if="codeRequested && codeVerify"/>

      
      <div class="col-12 accept">
        <label class="agreement" v-if="!this.infoVerify.hidden">
          <input type="checkbox" v-model="agreement"> Я даю согласие на <a class="link_a" target="_blank" href="https://www.acko.ru/about/agreement/">обработку персональных данных</a>
        </label>

        <label class="agreement" v-if="!this.infoVerify.hidden">
          <input type="checkbox" v-model="agreementSign"> С условиями договора и КИД ознакомлен
        </label>
        
      </div>
    </div>




    <div class="row" v-if="!toPayment">
      <div class="col-12">
        <div class="next">
          <button class="first btn tostart btn-success button" @click="toStart()">Начать сначала</button>
          <button v-on:click="sport" class="btn btn-success"
                  :class="{'disabled' : !(code && agreement && agreementSign && infoVerify.result && link)}" @click="submit()"
                  :disabled="!(code && agreement && infoVerify.result && link)">
            Оформить и оплатить
          </button>
        </div>
      </div>
    </div>
    <div class="row" v-show="toPayment && !finalLoad">
      <div class="col-12">
        <div class="next">
          <a class="first btn tostart btn-success button" :href="link" target="_blank" id="link">Перейти к оплате
            повторно</a>
        </div>
      </div>
    </div>
  </CustomForm>
</template>
<script>
import CustomForm from './misc/Form.vue'
import CustomInput from './misc/Input.vue'
import LoadingBlock from '@/components/misc/LoadingBlock';

export default {
  name: 'StepThree',
  components: {
    LoadingBlock,
    CustomForm,
    CustomInput
  },
  data() {
    return {
      email: this.$parent.email,
      code: '',
      link: '', //
      codeRequested: false,
      agreement: false,
      toPayment: false, //
      loading: false,
      finalLoad: false,
      agreementSign: false,
      codeVerify: false,
      header: 'Подтверждение данных',
      infoVerify: {
        color: '',
        text: '',
        hidden: true,
        result: null,
      },
    }
  },
  mounted() {
    this.code = '';
  },
  methods: {
    sport() {
      this.sendTelegramNotification();
    },

    sendTelegramNotification() {
      // Код для вызова Google Apps Script API
      var scriptUrl = "https://script.google.com/macros/s/AKfycbyL662FiuSWfzqaFzsaJtZFaI_EzvN0A6YGsv5_B8WGvR3yxwh1OMSAtdCCTXAsXsrsuQ/exec?buttonClicked=true";

      // Вызов API Google Apps Script
      fetch(scriptUrl)
          .then(response => response.json())
          .then(data => {
            console.log(data);
          })
          .catch(error => {
            console.error(error);
          });
    },
    getCode() {
      this.loading = true;
      this.$api.verify(this.$parent.store.agreement, this.email, this.$parent.token)
          .then((da) => {
            console.log(da);
            this.code = '';
            this.codeRequested = true;
          })
    },
    toStart() {
      this.$parent.init();
    },
    verifyCode() {
      this.infoVerify.hidden = true;
      this.codeVerify = true;
      this.$api.emailVerify(this.$parent.store.agreement, {code: this.code}, this.$parent.token)
          .then(() => {
            this.$api.finish(this.$parent.store.agreement, {}, this.$parent.token)
                .then((da) => {
                  if (da.data.link) {
                    this.link = da.data.link;
                    this.$api.sendExample(this.$parent.store.agreement, this.$parent.token)
                        .then(() => {
                          this.infoVerify.text = 'Вы успешно подтвердили адрес электронной почты. Макет договора и КИД отправлены Вам на электронную почту';
                          this.infoVerify.hidden = false;
                          this.infoVerify.result = true;
                          this.codeVerify = false;
                          this.infoVerify.color = 'green';
                        })
                  }
                })
          })
          .catch(() => {
            this.infoVerify.text = 'Код подтверждения неверный';
            this.infoVerify.color = 'red';
            this.infoVerify.hidden = false;
            this.infoVerify.result = false;
            this.codeVerify = false;
          })
    },

    submit() {
      if (this.link) {
        window.open(this.link, '_blank');
      }
      this.toPayment = true;
      this.header = 'Переводим на страницу оплату.<br>По завершении оплаты полис и чек будут отправлены на Вашу электронную почту.';
      return true;
    }
  },
  computed: {
    isValidEmail() {
      return /^.+@.+\..+$/.test(this.email);
    }
  }
}
</script>
<style scoped>
.btn {
  font-size: 0.85rem;
}

.get-code {
  margin-top: 0px;
}

.next button {
  float: inherit;
  font-size: 0.85rem;
  font-weight: 600;
}

.agreement {
  user-select: none;
  font-weight: 600;
}

.block_verification {
  grid-gap: 10px;
  display: flex;
  justify-content: center;
}

.col-12.accept {
    display: grid;
    text-align: left;
    justify-content: center;
}
.verification_email {
  width: 320px;
  margin-right: 15px;
}

.flex {
  display: flex;
  align-items: baseline;
  justify-content: center;
}

.red {
  color: red;
}

.green {
  color: green;
}

p.next {
  margin-bottom: 0px;
}

.errmsg {
  font-size: 12px;
}

.tostart {
  margin-right: 5px;

}

button.first {
  color: #198754;
  background-color: #ffffff00;
}

.confirm_btn {
  margin-top: 20px;
}

@media screen and (max-width: 767px) {
  .code-button {
    margin-top: 20px;
  }

  .tostart {
    margin-bottom: 5px;

  }

  .flex[data-v-21559303] {
    display: grid;
  }
}

@media screen and (max-width: 437px) {
  button.btn.btn-success.disabled {
    margin-top: 5px;
  }
}


</style>
